import { useReducer } from "react";

const reducer = (state, action) => {
  if (typeof action === "function") {
    const actionGeneratedStates = action(state);

    return {
      ...state,
      ...actionGeneratedStates,
    };
  }

  return {
    ...state,
    ...action,
  };
};

/**
 * @description useAutoReducer is a hook that allows you to create a reducer with a state and a dispatch function.
 * @param {Object} initialState
 * @returns {[Object, Function]}
 */
export default function useAutoReducer(initialState = {}) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return [state, dispatch];
}
